import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Fade } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import { isSuccessState } from 'globals/utils';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsReportsTable from 'ui-elements/tables/FsReportsTable';
import FsPagination from 'ui-elements/tabs/FsPagination';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { PaginationWrapperBox } from './Reports.style-elements';
import { dummyPagination, headLabels } from './Reports.utils';

const Reports: React.FC = () => {
  const {
    reportsList: { status, getReports, init: initStore },
  } = useAppContext();

  useEffect(() => {
    initStore();
  }, [initStore]);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );

  return (
    <Fade in timeout={1000}>
      <FsPaper
        data-test="reports-page"
        title={defaultLocales.reportsPage.title}
      >
        <FsMinWidthScrollBox breakpointDown="md" minWidth={600}>
          <FsReportsTable
            rows={getReports()}
            headLabels={headLabels}
            isLongVersion
          />
        </FsMinWidthScrollBox>
        <FsMinWidthScrollBox minWidth={290}>
          <PaginationWrapperBox>
            <FsPagination paginationInfo={dummyPagination} />
          </PaginationWrapperBox>
        </FsMinWidthScrollBox>
      </FsPaper>
    </Fade>
  );
};

export default observer(Reports);
